import React, { Component } from 'react';

class NavBarComponent extends React.Component {
  onClickStart = () => {
    window.open('https://trybesl.typeform.com/to/nyjnzF3P', '_blank');
  };

  onClickTrybe = () => {
    window.location.href = 'https://trybe.fit';
  };

  onClickTrybe = () => {
    window.location.href = 'https://trybe.fit';
  }

  render() {
    return (
      <div className='nav-bar-container'>
        <div className='navbar-section'>
          <div className='navbar-content'>
            <div className='logo-container' onClick={this.onClickTrybe}>
              <img
                className='logo-img'
                src={require('../../images/trybe-logo-white.svg')}
              />
              <div className='logo-text'>TRYBE</div>
            </div>
            <div className='right-nav-bar'>
              <div className='faq-buttons'>
                <div
                  className='nav-text-clickable faq-button-primary'
                  style={{ textDecoration: 'none' }}
                >
                  FAQs
                </div>
                <div className='faq-options-container'>
                  <a href='/userFAQs' className='user-faq-option hide'>
                    Users
                  </a>
                  <a href='/FAQs' className='creator-faq-option hide'>
                    Creators
                  </a>
                </div>
              </div>

              <div className='nav-text-clickable' onClick={this.onClickStart}>
                GET STARTED
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = NavBarComponent;



// WEBPACK FOOTER //
// ./src/components/nav/NavBarComponent-Itay.js